import { activeRoute, tripAt } from './route';

/** Smoothly blends a per-leg value (taken at the middle of each leg) along the road, so hills rise and fall rather than jump. */
function blended(r: number, valueOf: (leg: { relief?: number }) => number): number {
  const { legs } = activeRoute();
  const centres = legs.map((leg) => ({ at: (leg.start + leg.end) / 2, value: valueOf(leg) }));
  const first = centres[0];
  const last = centres[centres.length - 1];
  if (!first || !last) return 0;
  if (r <= first.at) return first.value;
  if (r >= last.at) return last.value;
  const i = centres.findIndex((c) => c.at > r);
  const a = centres[i - 1]!;
  const b = centres[i]!;
  return a.value + ((b.value - a.value) * (r - a.at)) / (b.at - a.at);
}

/** How hilly the country beside the road is at distance `s`, 0 (flat city) to 1 (the Akuapem ridge). */
export function reliefAt(s: number): number {
  return blended(tripAt(s).r, (leg) => leg.relief ?? 0);
}

/** The slope of the road under the trotro in the direction it is driving: + climbs, − descends. */
export function gradeAt(s: number): number {
  const { r, dir } = tripAt(s);
  const { legs } = activeRoute();
  const leg = legs.find((l) => r >= l.start && r < l.end) ?? legs[legs.length - 1];
  const grade = leg?.grade ?? 0;
  return grade === 0 || dir === 'out' ? grade : -grade;
}
